<template>
  <div class="main-chapter">
    <div v-if="!course">
      {{ $t("chapter.chapter-course-by-types.text") }}
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <div v-if="course" class="chapter-course">
      <div
        v-for="type of Object.keys(normalizeItems())"
        :style="{
          height: calculateHeight(type)
        }"
        class="collapsed"
      >
        <div class="lesson-type" @click="pickType(type)">
          <div>
            <div>{{ types[type] }}</div>
          </div>
          <div class="lesson-icon">
            <inline-svg :src="imgTypes[type]" class="check-svg"></inline-svg>
          </div>
          <div class="arrow">
            <img :src="Arrow" alt="" />
          </div>
        </div>
        <div
          class="lessons"
          v-for="lesson of normalizeItems()[type]"
          @click="goTo(lesson)"
        >
          {{ lesson.name }}

          <div class="lesson-icon">
            <inline-svg :src="imgTypes[type]" class="check-svg"></inline-svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "./chapter-course.scss";
import Arrow from "./assets/arrow.png";
import lesson from "../../assets/svg/lesson.svg";
import wordshalf from "../../assets/svg/wordshalf.svg";
import wordsfull from "../../assets/svg/wordsfull.svg";
import grammar from "../../assets/svg/grammar.svg";
import sentences from "../../assets/svg/sentences.svg";
import course from "../../store/course";

export default {
  name: "ChapterCourseByType",
  props: ["course"],
  data() {
    return {
      pickedType: "",
      Arrow,
      imgTypes: {
        lesson,
        wordshalf,
        wordsfull,
        grammar,
        sentences
      },
      types: {
        lesson: this.$t("chapter.chapter-course-by-types.lesson"),
        wordshalf: this.$t("chapter.chapter-course-by-types.wordshalf"),
        wordsfull: this.$t("chapter.chapter-course-by-types.wordsfull"),
        sentences: this.$t("chapter.chapter-course-by-types.sentences"),
        grammar: this.$t("chapter.chapter-course-by-types.grammar")
      }
    };
  },
  mounted() {},
  created() {},

  methods: {
    calculateHeight(type) {
      return this.pickedType === type
        ? this.normalizeItems()[type].length * 53 + 53 + "px"
        : "53px";
    },
    pickType(type) {
      if (this.pickedType === type) {
        this.pickedType = "";
        return;
      }
      this.pickedType = type;
    },
    normalizeItems() {
      const lessons = this.course.parts.reduce((acc, item) => {
        return [...acc, ...item.lessons];
      }, []);

      const lessonsByTypes = lessons.reduce((acc, lesson) => {
        const newObject = { ...acc };
        if (!newObject[lesson.type]) {
          newObject[lesson.type] = [];
        }
        newObject[lesson.type].push(lesson);

        return newObject;
      }, {});

      return lessonsByTypes;
    },
    goTo: function(lesson) {
      this.$store.commit({
        type: "setCurrentGame",
        lesson,
        courseId: course.order,
        courseName: course.name
      });
      this.$router.push({
        path: `../play/${lesson.type}/${lesson.game_id}`
      });
    }
  },
  components: {
    // ProgressBar
  }
};
</script>

<style scoped>
.lesson-type {
  display: flex;
  padding: 12px;
  border: 1px solid black;
  font: var(--large-font);
}

.collapsed {
  transition: all 0.3s;
  overflow-y: hidden;
}

.lessons {
  display: flex;
  font: var(--large-font);
  height: 53px;
  transition: all 0.3s;
  padding: 4px;
}
</style>



// WEBPACK FOOTER //
// chapter-course-by-types.vue?38190562